import { IconSymbol } from '@uhg-abyss/web/ui/IconSymbol';
import { Text } from '@uhg-abyss/web/ui/Text';
import find from 'lodash/find';
import React, { useState } from 'react';
import { useMediaQuery } from 'usehooks-ts';

import { useLagoon } from '../../../hooks/useLagoon';
import { ConstantsLagoon } from '../../ConstantsLagoon';
import { mobileOnly } from '../../ConstantsStyles';
import {
  BenefitContainer,
  BenefitsSubHeadingContainer,
} from '../../PSXHeader/SearchBar/KeywordSearchDropdown/BenefitsList.styled';
import { Divider } from '../../PSXHeader/SearchBar/KeywordSearchDropdown/KeywordSearchDropdown.styled';
import { BHProviderComparisonModal } from '../BHProviderComparisonModal/BHProviderComparisonModal';
import {
  CardContainer,
  CompareProviderTypesButton,
  SectionHeadingRow,
  SectionMessageText,
  containerCss,
} from './CompareProviderTypesList.styled';

export const CompareProviderTypesList = ({
  showDivider = true,
  isCard = false,
  onCompareClick,
}: {
  showDivider?: boolean;
  isCard?: boolean;
  onCompareClick?: () => void;
}) => {
  const isMobileView = useMediaQuery(mobileOnly);
  const uiMessaging = useLagoon('ui-messaging')();
  const [isModalOpen, setIsModalOpen] = useState(false);

  const compareProviderTypesCtaContent = find(uiMessaging, {
    key: ConstantsLagoon.UI_MESSAGING.BH_COMPARE_PROVIDER_TYPES
      .COMPARE_PROVIDER_TYPES_CTA,
  });

  const compareProviderTypesButtonText = find(uiMessaging, {
    key: ConstantsLagoon.UI_MESSAGING.BH_COMPARE_PROVIDER_TYPES
      .COMPARE_PROVIDER_TYPES_BUTTON_TEXT,
  });

  const content = (
    <>
      <SectionHeadingRow>
        <IconSymbol icon="info" size={20} />
        <Text
          data-testid="compare-provider-types-section-heading"
          fontWeight="bold"
        >
          {compareProviderTypesCtaContent?.title}
        </Text>
      </SectionHeadingRow>
      <BenefitsSubHeadingContainer css={{ gap: '8px' }} isMobile={isMobileView}>
        <SectionMessageText>
          {compareProviderTypesCtaContent?.message}
        </SectionMessageText>
        <CompareProviderTypesButton
          data-testid="compare-provider-types-link"
          onClick={() =>
            onCompareClick ? onCompareClick() : setIsModalOpen(true)
          }
        >
          {compareProviderTypesButtonText?.title}
        </CompareProviderTypesButton>
      </BenefitsSubHeadingContainer>
    </>
  );

  return (
    <React.Fragment>
      {showDivider && !isCard && <Divider />}
      {isCard ? (
        <CardContainer>{content}</CardContainer>
      ) : (
        <BenefitContainer css={containerCss}>{content}</BenefitContainer>
      )}
      <BHProviderComparisonModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
      />
    </React.Fragment>
  );
};
